export const TOGGLE_MAP_VISIBLE = "TOGGLE_MAP_VISIBLE";
export const TOGGLE_DISTANCE_TOOL = "TOGGLE_DISTANCE_TOOL";
export const SET_MAP_REFERENCE = "SET_MAP_REFERENCE";
export const SET_MAP_ENTITIES = "SET_MAP_ENTITIES";
export const SET_MAP_OFFSET = "SET_MAP_OFFSET";
export const SET_MAP_OFFSET_EXTERNAL = "SET_MAP_OFFSET_EXTERNAL";
export const SET_IN_EDIT_GEO = "SET_IN_EDIT_GEO";
export const CLEAR_MAP_REFERENCE = "CLEAR_MAP_REFERENCE";
